import { render, staticRenderFns } from "./BoardChart.vue?vue&type=template&id=22878882&scoped=true"
import script from "./BoardChart.vue?vue&type=script&lang=js"
export * from "./BoardChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22878882",
  null
  
)

export default component.exports